var modules_997b7aad = {"logoLink":"_1ggbbxk","logo":"_1iq0mw0"};
import "../../../assets/DVut-bjj.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
